import { Component, OnInit } from '@angular/core';
import { ViewsService } from '@services/views.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataModelService } from '@services/data-model.service';
import { NotificationsService } from '@services/notifications.service';
import { MenuItem } from 'primeng/api';
@Component({
    selector: 'app-model-modes',
    templateUrl: './model-modes.component.html',
    styleUrls: ['./model-modes.component.scss'],
    standalone: false
})
export class ModelModesComponent implements OnInit {
  constructor(
    private view: ViewsService,
    private route: ActivatedRoute,
    private router: Router,
    private dataModel: DataModelService,
    private notifications: NotificationsService
  ) {}
  modelId;
  type;
  modes = [];
  menu: MenuItem[] = [];
  newMode: string = '';
  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('id');
      //  this.dataModel.getTypes(this.modelId).subscribe(type => this.type = type[0])
      this.getModes();
      console.log(this.modes);
    });
  }
  /**
   * Converst mode list into nebular menu array
   * @param modes List of modes
   *
   */
  buildMenu(modes): MenuItem[] {
    let menu: MenuItem[] = modes.map(mode => {
      let item: MenuItem = {
        label: mode.mode,
        id: mode.id,
        command: event => this.selectMode(event.item?.id),
      };
      return item;
    });
    console.log(menu);
    return menu;
  }

  createMode(mode) {
    if (!this.exists(mode) && this.newMode != '') {
      this.view.createMode(this.type, mode, { content: [] }).subscribe(d => {
        if (d && d.errorMessage) {
          this.notifications.popNotification(d.errorMessage, 'X');
        } else {
          this.newMode = '';
          this.getModes();
        }
      });
    }
  }

  exists(mode) {
    var exists = false;
    this.modes.forEach(m => {
      if (m.mode === mode) exists = true;
    });
    return exists;
  }

  private getModes() {
    this.view.getModes(this.type).subscribe(modes => {
      this.modes = modes;
      this.menu = this.buildMenu(modes);
    });
  }

  selectMode(val: any) {
    console.log(val);
    this.router.navigateByUrl('/views/' + val);
  }
}
